module.exports = __webpack_public_path__ + "static/media/Apple-Macbook-Gold.aa1245f2.png";